export const POPUP_MODAL_TIMEOUT_DEFAULT = 5000;
